import { actsAsAdmin } from 'shared/lib/roles'
import { useAuthStore } from 'shared/store/auth'
import { useLocationScope } from 'shared/store/location-scope'

/**
 * The Point a money page is about: an admin names it (nothing is read until they
 * do); an operator's Point is resolved by the backend, so no `pointId` is sent.
 */
export function usePointOfPage(): { locationId?: string; scoped: boolean } {
	const isAdmin = actsAsAdmin(useAuthStore((s) => s.user.role))
	const { locationId: selected } = useLocationScope()
	return {
		locationId: isAdmin ? (selected ?? undefined) : undefined,
		scoped: isAdmin ? !!selected : true,
	}
}
